module.exports = __webpack_public_path__ + "static/media/productCenter.4f8320d2.png";